export default {
  lang: 'es-MX',
  currency: 'es-MX'
}
